import { For } from "solid-js";

type Step = "claim" | "profile" | "interests" | "optin";

const STEPS: { id: Step; label: string }[] = [
  { id: "claim", label: "Ticket" },
  { id: "profile", label: "Profile" },
  { id: "interests", label: "Topics" },
  { id: "optin", label: "Join" },
];

type Props = {
  current: Step;
  /** Hide the directory opt-in step when building a draft without a ticket. */
  draft?: boolean;
};

export function WizardStepper(props: Props) {
  const steps = () => (props.draft ? STEPS.filter((s) => s.id !== "optin") : STEPS);
  const currentIdx = () => steps().findIndex((s) => s.id === props.current);

  return (
    <div class="wizard-stepper" aria-label="Setup progress">
      <For each={steps()}>
        {(step, index) => {
          const idx = index();
          const done = () => idx < currentIdx();
          const active = () => idx === currentIdx();

          return (
            <>
              <div class="wizard-step">
                <div
                  class={`wizard-step-dot${done() ? " wizard-step-dot--done" : ""}${active() ? " wizard-step-dot--active" : ""}`}
                  aria-current={active() ? "step" : undefined}
                >
                  {done() ? "✓" : idx + 1}
                </div>
                <span class={`wizard-step-label${active() ? " wizard-step-label--active" : ""}`}>
                  {step.label}
                </span>
              </div>
              {idx < steps().length - 1 && (
                <div class={`wizard-step-line${idx < currentIdx() ? " wizard-step-line--done" : ""}`} />
              )}
            </>
          );
        }}
      </For>
    </div>
  );
}
